import React from "react";

import UsersIcon from "@uui/Users01";
import { isEmpty } from "lodash/fp";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import useMeetingReport from "@app/analytics/MeetingReport/hooks/useMeetingReport";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import ParticipantsPopoverMenu from "./ParticipantsPopoverMenu";

interface ParticipantsPopoverProps {
  disabled: boolean;
}

const ParticipantsPopover = ({ disabled }: ParticipantsPopoverProps) => {
  const { anchorElement, onClose, open, onClick } = useAnchorElement();

  const { meetingReport } = useMeetingReport();
  const numParticipants = meetingReport?.participants?.length ?? 0;
  const talkTimeData = meetingReport?.talkTimeData ?? [];

  if (!numParticipants || isEmpty(talkTimeData)) return null;

  const id = open ? "participants-popover" : undefined;

  return (
    <>
      <ParticipantsPopoverMenu
        id={id}
        title={`Meeting Participants (${numParticipants})`}
        open={open}
        anchorEl={anchorElement}
        onClose={onClose}
        data={talkTimeData}
      />
      <HeaderButton
        className="meeting-report__header__participants"
        startIcon={<UsersIcon />}
        aria-describedby={id}
        onClick={onClick}
        disabled={disabled}
      >
        Participants ({numParticipants})
      </HeaderButton>
    </>
  );
};

export default ParticipantsPopover;
